import { IModules, IP60ModulePage } from '~/lib/data-contract';
import { DynamicBlockList } from '~/templates/blocks/components/DynamicBlockList/DynamicBlockList';

export type P60ModulePageProps = Omit<IP60ModulePage, 'type'>;

export const P60ModulePage = (props: P60ModulePageProps) => {
	return <DynamicBlockList elements={props.pageElements as any as IModules[]} />;
};
